var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 31,
    viewBox: "0 0 30 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.9628 20.3947C17.1841 20.4963 17.4334 20.5195 17.6696 20.4605C17.9058 20.4015 18.1149 20.2638 18.2624 20.0701L18.6428 19.5718C18.8424 19.3057 19.1012 19.0897 19.3988 18.9409C19.6963 18.7922 20.0244 18.7147 20.3571 18.7147H23.5714C24.1397 18.7147 24.6847 18.9405 25.0866 19.3423C25.4885 19.7442 25.7142 20.2892 25.7142 20.8576V24.0718C25.7142 24.6402 25.4885 25.1852 25.0866 25.5871C24.6847 25.9889 24.1397 26.2147 23.5714 26.2147C18.4565 26.2147 13.5511 24.1828 9.9343 20.566C6.31753 16.9493 4.28564 12.0439 4.28564 6.92899C4.28564 6.36067 4.51141 5.81562 4.91327 5.41376C5.31514 5.0119 5.86018 4.78613 6.4285 4.78613H9.64279C10.2111 4.78613 10.7562 5.0119 11.158 5.41376C11.5599 5.81562 11.7856 6.36067 11.7856 6.92899V10.1433C11.7856 10.4759 11.7082 10.804 11.5594 11.1016C11.4106 11.3991 11.1946 11.658 10.9285 11.8576L10.4271 12.2336C10.2304 12.3838 10.0917 12.5975 10.0347 12.8383C9.97767 13.0791 10.0058 13.3322 10.1142 13.5547C11.5785 16.5288 13.9868 18.9341 16.9628 20.3947Z",
    stroke: "#F3F3F3",
    strokeWidth: 2.14286,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCall);
export default __webpack_public_path__ + "static/media/call.631b5a06a47f8deea9f9cb9222b466c3.svg";
export { ForwardRef as ReactComponent };